export class ToolsConstants
{
    public static Application: string = 'ToolsApi';
    public static BaseUrl = 'tools';
    public static DefaultUrl = `/${ToolsConstants.BaseUrl}`;
}
